import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchReferral } from "../core/api/referral";
import InviteButton from "../components/InviteButton";

const HomePage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [shareUrl, setShareUrl] = useState(null);
  const [targetReferralCode, setTargetReferralCode] = useState("");
  const [referralBoots, setReferralBoots] = useState(0);
  const [totalGamePoint, setTotalGamePoint] = useState(0);
  const [shareMessage, setShareMessage] = useState("");

  const tg_info = JSON.parse(localStorage.getItem("tg_info"));
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tgUserId = queryParams.get("tg_user_id");
    const gameName = queryParams.get("game_name");
    const botName = queryParams.get("bot_name")
      ? queryParams.get("bot_name")
      : tg_info?.botName;
    if (botName) {
      setShareUrl(
        `https://t.me/share/url?url=https://t.me//${botName}?start=referralapp=referral=`
      );
    }
    if (tgUserId && gameName && botName) {
      localStorage.removeItem("tg_info");
      localStorage.setItem(
        "tg_info",
        JSON.stringify({ tgUserId, gameName, botName })
      );
    }
    const getReferral = async () => {
      const currentTgUserId = tgUserId
        ? tgUserId
        : JSON.parse(localStorage.getItem("tg_info"))?.tgUserId;
      if (currentTgUserId) {
        const resp = await fetchReferral(currentTgUserId);
        if (resp) {
          setTargetReferralCode(resp.referral_code);
          setShareMessage("&text=" + decodeURIComponent(resp.referral_message));
          setReferralBoots(resp.referral_invite_bonus_boots);
          setTotalGamePoint(resp.total_game_points);
        }
      }
    };
    getReferral();
  }, [location.search, tg_info?.botName]);

  console.log("share link", shareUrl + targetReferralCode + shareMessage);

  return (
    <div className="HomePageContainer">
      {/* <audio id="audio" loop autoPlay>
        <source src="/testing/backgroundMusic.wav" type="audio/wav" />
      </audio> */}
      <div className="containerContent">
        <div className="gamePageImage">
          <div className="pointBar">
            <img
              src="/image/pointAndCoin.png"
              alt="pointAndCoin"
              width={"81px"}
            />
            <div
              style={{
                fontSize: "20px",
                fontWeight: 600,
                lineHeight: "28px",
                textAlign: "center",
              }}>
              {totalGamePoint.toLocaleString()}
            </div>
          </div>
          <img
            src="/image/L4W_icon.png"
            alt="game"
            width={"100%"}
            className="L4WImage"
          />
          <img
            src="/image/gamePage.png"
            alt="game"
            width={"100%"}
            style={{ height: "auto", objectFit: "cover" }}
          />
          <div className="Live4WellRunsImage">Live4Run</div>
        </div>
        <div className="gamePageGiftImage">
          <img
            src="/image/gift.png"
            alt="game"
            width={"90%"}
            height={"auto"}
            className="giftImage"
          />
        </div>
        <div className="buttonContainer">
          <div className={"homeButton"} onClick={() => navigate(`/game`)}>
            Start Now
          </div>
          <InviteButton
            shareUrl={shareUrl + targetReferralCode + shareMessage}
            referralBoots={referralBoots}
          />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
